import {Component, OnInit, ViewChild} from '@angular/core';
import {Subject} from "rxjs/Subject";
import {DialogService} from "ng2-bootstrap-modal";
import {Observable} from "rxjs/Observable";
import {SendSignalService} from "../../../_services/send-signal.service";
import {DataTableDirective} from "angular-datatables";
import {PopupSettingSendSignalComponent} from "../popup-setting-send-signal/popup-setting-send-signal.component";
import {PopupManageCoinInCmcComponent} from "./popup-manage-coin-in-cmc/popup-manage-coin-in-cmc.component";

@Component({
    selector: 'app-manage-coin-in-cmc',
    templateUrl: './manage-coin-in-cmc.component.html',
    styleUrls: ['../send-signal-event.component.css']
})
export class ManageCoinInCmcComponent implements OnInit {

    delayTimer: any;
    dtTrigger: Subject<any> = new Subject();
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    objPopUp: any;
    coinName: string;
    parameters: any = {};

    //declare callback object
    callback: any = {};
    /**
     * filterBy = 2; // load all
     * filterBy = 1; // load coin in system - not has CMC
     * filterBy = 0; // load all In system - has CMC
     */
    filterBy = 1; // load coin in system - not has CMC

    constructor(private dialogService: DialogService,
                private sendSignalService: SendSignalService,
    ) {
    }

    ngOnInit() {
        this.sendSignalTable();
    }

    sendSignalTable() {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "asc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.coinName || '';
                parameters["search"]["rank_cmc"] = self.filterBy;

                //assign parameters object
                self.parameters = parameters;
                //assign callback object
                self.callback = callback;

                self.sendSignalService.getListCoinForCMC(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: "コイン名",
                    name: "coin_name",
                    className: "all text-justify",
                    data: 'coin_name',
                },
                {
                    title: "CMCでの他のコイン名",
                    data: 'coin_name_cmc',
                    name: "coin_name_cmc",
                    className: "all text-justify",
                },
                {
                    title: "CMCでのランキング",
                    data: function (rank) {
                        return rank.coin_rank_cmc > 0 ? rank.coin_rank_cmc : '';
                    },
                    name: "coin_rank_cmc",
                    className: "all text-justify",
                },
                {
                    data: function (d) {
                        return `<button class="btn btn-sm btn-edit">編集</button>`;
                    },
                    width: '120px',
                    className: "all text-center",
                    orderable: false
                },
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                $('.btn-edit', row).bind('click', () => {
                    self.openModalSettingCMC(data);
                });

                var btn_edit = $(row).find('td').find('.btn-edit');
                btn_edit.css({
                    'background-color': 'deepskyblue',
                    'color': '#fff'
                });
                btn_edit.mouseover(function () {
                    btn_edit.css('opacity', '0.9');
                });
                btn_edit.mouseout(function () {
                    btn_edit.css('opacity', '1');
                });

                if (data['is_active'] == 1) {
                    $(row).css('background-color', '#3c8dbc');

                    var btn_active_bot = $(row).find('td:last').find('.btn-active-bot');
                    btn_active_bot.css({
                        'background-color': 'HotPink',
                        'border-color': 'HotPink'
                    });
                    btn_active_bot.mouseover(function () {
                        btn_active_bot.css('opacity', '0.8');
                    });
                    btn_active_bot.mouseout(function () {
                        btn_active_bot.css('opacity', '1');
                    });
                }
                return row;
            }
        };
    }

    openModalSettingCMC(dataObject: any) {
        let self = this;
        self.objPopUp = {
            data: dataObject,
            titlePopup: 'CMCでのコイン設定',
            btnSaveOrUpdate: '更新',
            coinName: dataObject.coin_name,
            otherCoinName: dataObject.coin_name_cmc
        };

        this.dialogService.addDialog(PopupManageCoinInCmcComponent, self.objPopUp).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page
        this.sendSignalService.getListCoinForCMC(this.parameters).subscribe(result => {
            this.callback({
                draw: this.parameters['draw'],
                data: result.data,
                recordsTotal: result.data.length,
                recordsFiltered: result.recordsTotal
            });
        });
    }

    onChangeFilter(value) {
        this.filterBy = value;
        this.renderDataTable();
    }

    renderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    valueChange(newValue) {
        this.coinName = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.renderDataTable();
        }, 600); // Will do the ajax stuff aft
    };
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/send-signal-event/manage-coin-in-cmc/manage-coin-in-cmc.component.ts